import React from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import {
  Container,
} from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import PropertyAmenitiesTable from "./PropertyAmenitiesTable"
import "../../../../assets/scss/custom.scss"

const PropertyAmenities = props => {
  return (
    <>
      {
        <React.Fragment>
          <div className="page-content">
            <MetaTags>
              <title>Property | EEFind </title>
            </MetaTags>
            <Container fluid>
              <Breadcrumbs title="Property" breadcrumbItem="Property Amenities" />
              <PropertyAmenitiesTable
                queryCondition={null}
                activeFilters={null}
                filterQueryConditions={null}
                showCreateBtn={true}
              />
            </Container>
          </div>
        </React.Fragment>
      }
    </>
  )
}
PropertyAmenities.propTypes = {}
export default withRouter(PropertyAmenities)
